module.exports = __webpack_public_path__ + "img/m3.e89b42ca.jpg";